import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('🚨 Erro no componente filho:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ background: '#fee', padding: '1rem', border: '1px solid red', margin: '1rem' }}>
          <strong>Erro no widget:</strong> Algo deu errado no BlopsAI.
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
